module.exports = __webpack_public_path__ + "99713f3e136df92d8ebfcded6a8ad0e4.gif";